import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const TitleColumns = () => (
    <>
            <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignY="center" alignX="center">
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1} alignY="center" alignX="center">
            <I18n component="span" id="comexTransaction.table.beneficiary" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1} alignY="center" alignX="center" >
            <I18n component="span" id="comexTransaction.table.amount" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1} alignY="center" alignX="center">
            <I18n component="span" id="comexTransaction.table.creationDate" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} rowStart={1} rowWidth={1} alignY="center" alignX="center">
            <I18n component="span" id="comexTransaction.table.condition" />
        </GridTable.Data>

    </>
);
export default TitleColumns;
